import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { Message } from "../../../@types/message";
import axiosInstance from "../../../utils/axiosConfig";

export const addDocumentComment = createAsyncThunk(
  "documentUpdate/addDocumentComment",
  async (data, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const user = state.userAuthentication.user;
      const documentId = state.documentShow.document.id;
      const comment = state.documentUpdate.commentText;

      const { data } = await axiosInstance.post(`${api.baseURL}message`, {
        createdBy: user?.id,
        document: documentId,
        room: documentId,
        text: `comentó `,
        comment,
        module: "document",
      });

      return data as Message;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);
